var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLbSearch20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon / search"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M13.0303 11.9697C12.7374 11.6768 12.2626 11.6768 11.9697 11.9697C11.6768 12.2626 11.6768 12.7374 11.9697 13.0303L12.5 12.5L13.0303 11.9697ZM16.9697 18.0303C17.2626 18.3232 17.7374 18.3232 18.0303 18.0303C18.3232 17.7374 18.3232 17.2626 18.0303 16.9697L17.5 17.5L16.9697 18.0303ZM8.33333 14.1667V13.4167C5.52589 13.4167 3.25 11.1408 3.25 8.33333H2.5H1.75C1.75 11.9692 4.69746 14.9167 8.33333 14.9167V14.1667ZM2.5 8.33333H3.25C3.25 5.52589 5.52589 3.25 8.33333 3.25V2.5V1.75C4.69746 1.75 1.75 4.69746 1.75 8.33333H2.5ZM8.33333 2.5V3.25C11.1408 3.25 13.4167 5.52589 13.4167 8.33333H14.1667H14.9167C14.9167 4.69746 11.9692 1.75 8.33333 1.75V2.5ZM14.1667 8.33333H13.4167C13.4167 11.1408 11.1408 13.4167 8.33333 13.4167V14.1667V14.9167C11.9692 14.9167 14.9167 11.9692 14.9167 8.33333H14.1667ZM12.5 12.5L11.9697 13.0303L16.9697 18.0303L17.5 17.5L18.0303 16.9697L13.0303 11.9697L12.5 12.5Z",
  fill: "white",
  fillOpacity: 0.6
}))));
export default SvgLbSearch20;